(function(){
 var root=document.getElementById('szgCharts');
 if(!root)return;
 var st={cat:'family',grp:'body',role:'',unit:'in'};
 function panels(){return [].slice.call(root.querySelectorAll('.szg-p'));}
 function avail(cat,grp){
  var s={},seen={};
  panels().forEach(function(p){
   if(p.dataset.cat!==cat)return;
   if(grp&&p.dataset.grp!==grp)return;
   if(!seen[p.dataset.role]){seen[p.dataset.role]=1;s[p.dataset.role]=p.dataset.roleName;}
  });
  return s;
 }
 function groupsFor(cat){
  var g=[],seen={};
  panels().forEach(function(p){
   if(p.dataset.cat===cat&&!seen[p.dataset.grp]){
    seen[p.dataset.grp]=1;g.push([p.dataset.grp,p.dataset.grpName]);}
  });
  return g;
 }
 function render(){
  // 分组/角色按钮都已在 HTML 里（SEO：文案不能靠 JS 生成），这里只切 hidden + 选中态
  var gs=groupsFor(st.cat), gw=document.getElementById('szgGrpWrap');
  gw.hidden=gs.length<2;
  if(!gs.some(function(g){return g[0]===st.grp}))st.grp=gs[0]?gs[0][0]:'';
  [].forEach.call(gw.querySelectorAll('button[data-grp]'),function(b){
   b.hidden=b.dataset.forCat!==st.cat;
   b.setAttribute('aria-pressed', String(!b.hidden && b.dataset.grp===st.grp));
  });
  var rs=avail(st.cat,st.grp),keys=Object.keys(rs);
  if(keys.indexOf(st.role)<0)st.role=keys[0]||'';
  [].forEach.call(document.querySelectorAll('#szgRoles button[data-role]'),function(b){
   b.hidden=!(b.dataset.forCat===st.cat&&b.dataset.forGrp===st.grp);
   b.setAttribute('aria-selected', String(!b.hidden && b.dataset.role===st.role));
  });
  // 单位开关：换算表没有单位维度
  var hasUnit=panels().some(function(p){
   return p.dataset.cat===st.cat&&p.dataset.grp===st.grp&&p.dataset.unit==='cm';});
  document.getElementById('szgUnitWrap').hidden=!hasUnit;
  var u=hasUnit?st.unit:'in';
  panels().forEach(function(p){
   p.hidden=!(p.dataset.cat===st.cat&&p.dataset.grp===st.grp&&
              p.dataset.role===st.role&&p.dataset.unit===u);
  });
  root.querySelectorAll('[data-cat-btn]').forEach(function(b){
   b.setAttribute('aria-pressed',b.dataset.catBtn===st.cat);});
  root.querySelectorAll('[data-unit]').forEach(function(b){
   b.setAttribute('aria-pressed',b.dataset.unit===u);});
 }
 root.addEventListener('click',function(e){
  var b=e.target.closest('button');if(!b)return;
  if(b.dataset.catBtn){st.cat=b.dataset.catBtn;st.role='';}
  else if(b.dataset.grp)st.grp=b.dataset.grp;
  else if(b.dataset.role)st.role=b.dataset.role;
  else if(b.dataset.unit)st.unit=b.dataset.unit;
  else return;
  render();
 });
 render();
})();